import * as Sentry from '@sentry/react';

type FileOperation = 'upload' | 'download';

export const sentryCaptureFileError = (data: {
  operation: FileOperation;
  error: Error;
  filename?: string;
  fileSize?: number;
  contentType?: string;
  url?: string;
  status?: number;
}) => {
  const { operation, error, filename, fileSize, contentType, url, status } = data;

  // Sanitize URL - remove query params (may contain tokens)
  const sanitizedUrl = url?.split('?')[0];

  const sentryMessage = [
    `File ${operation} error`,
    filename && `[${filename}]`,
    status && `(${status})`,
  ]
    .filter(Boolean)
    .join(' · ');

  Sentry.captureException(new Error(sentryMessage), {
    fingerprint: ['file_error', operation, String(status || 'no_status')],
    tags: {
      type: 'file_error',
      operation,
      status_code: status?.toString(),
      content_type: contentType,
    },
    extra: {
      filename,
      file_size: fileSize,
      url: sanitizedUrl,
      original_error: error.message,
      original_stack: error.stack,
    },
  });
};
